

import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";
import { AuthContext } from "src/context/authContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import FooterText from "src/components/footerText";
import { CaseListingType, onGoingTreatmentType, ProvidersObject, StatisticsApiResponse, statisticsErrorAndData } from "./types";
import CaseVolumeHorizontal from "src/components/manufacturer/caseVolumeHorizontal";
import PieChartTerritories from "src/components/manufacturer/pieChartTerritories";
import Practices from "src/components/manufacturer/practices";
import Provider from "src/components/manufacturer/provider";
import CaseDetail from "src/components/manufacturer/caseDetail";
import { StatisticsSearchProps, TerritoriesSearchProps } from "src/components/manufacturer/statistics/types";
import TerritoriesFilter from "src/components/manufacturer/territoriesFilter";
import OngoingTreatment from "src/components/manufacturer/ongoingTreatments";

import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
// import OngoingTreatment from "src/components/manufacturer/ongoingTreatment";
// import CaseFilter from "src/components/manufacturer/statistics";

const Territories: FC = (): JSX.Element => {



  const { destroySession } = useContext(AuthContext)
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  let [searchParams, updateSearchParams] = useSearchParams();
  const params = useParams();

  // const { state } = useLocation();
  // const [territoryState, setTerritoryState] = useState(null);

  // useEffect(() => {

  //   if (state) {
  //     // Normal client-side navigation
  //     setTerritoryState(state);
  //     sessionStorage.setItem("territoryState", JSON.stringify(state));
  //   } else {
  //     // Page was reloaded
  //     const saved = sessionStorage.getItem("territoryState");
  //     console.log("Final state:", sessionStorage.getItem("territoryState"), state);

  //     if (saved) {
  //       setTerritoryState(JSON.parse(saved));
  //     }
  //   }
  // }, [state]);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => setLoader(), [])


  const [queryParams, changeQueryParams] = useState<TerritoriesSearchProps>({
    start_date:
      searchParams.get("start_date") ||
      format(new Date().setDate(new Date().getDate() - 60), "yyyy-MM-dd"),
    end_date:
      searchParams.get("end_date") ||
      format(new Date().setDate(new Date().getDate() + 1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "day",
    filter: searchParams.get("filter") || "",
    filter_type: searchParams.get("filter_type") || "",
    type: searchParams.get('type') || "territories",
    role: searchParams.get('role') || "rep",
    id: searchParams.get('id') ?? params?.Id ?? "0",
    case_id: searchParams.get('case_id') || "",
    search_str: searchParams.get('search_str') || "",
  });



  const { loading: statisticsLoading, data: statisticsData, error: errorAndData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams, {}, false);

  useEffect(() => {
    if (errorAndData) {
      const { error, code } = errorAndData as unknown as statisticsErrorAndData;
      hideLoader();
      showToast([error || `Can't fetch statistics right now. Please try again in a while.`], ToastTypes.ERROR);

      if (code === 401) {
        destroySession();
        navigate(`/users/sign_in`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorAndData]);

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);

  const updateQueryParamsAndCallAPI = (
    updatedQueries: TerritoriesSearchProps | StatisticsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({
        type: searchParams.get('type') || "territories",
        role: searchParams.get('role') || "rep",
        id: searchParams.get('id') ?? params?.Id ?? "0",
        period: "day",
      });
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 60),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate() + 1),
          "yyyy-MM-dd"
        ),
        period: "day",
        filter: "",
        filter_type: "",
        case_id: "",
        search_str: "",
        type: searchParams.get('type') || "territories",
        role: searchParams.get('role') || "rep",
        id: searchParams.get('id') ?? params?.Id ?? "0",
      });
    } else {
      const params = new URLSearchParams({ ...queryParams, ...updatedQueries });
      updateSearchParams(params.toString(), { replace: false });
      changeQueryParams({ ...queryParams, ...updatedQueries });
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  useEffect(() => {
    const updatedParams = {
      start_date: searchParams.get('start_date') || format((new Date()).setDate((new Date()).getDate() - 60), "yyyy-MM-dd"),
      end_date: searchParams.get('end_date') || format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
      period: searchParams.get('period') || "day",
      filter: searchParams.get('filter') || "",
      filter_type: searchParams.get('filter_type') || "",
      type: searchParams.get('type') || "territories",
      role: searchParams.get('role') || "rep",
      id: searchParams.get('id') ?? params?.Id ?? "0",
      case_id: searchParams.get('case_id') || "",
      search_str: searchParams.get('search_str') || "",
    };
    if (!statisticsLoading) {
      setLoader();
      changeQueryParams(updatedParams);
      getStatsData({}, {}, updatedParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);


  return (
    <div className="container-fluid auth-page mb-4 overflow-x-hidden">
      <AuthMaunfacturerSubHeader />

      <TerritoriesFilter
        defaultQueryParams={queryParams}
        updateQueryParams={updateQueryParamsAndCallAPI}
      />
      <div className="mt-3">
        {statisticsData && <CaseVolumeHorizontal StatisticsObjectType={statisticsData.data} />}
      </div>
      <div className="mb-3">
        {statisticsData && <PieChartTerritories StatisticsObjectType={statisticsData.data} />}
      </div>

      <div className="row g-3">
        <div className="col-12 col-sm-12 col-md-6 d-flex">
          <Practices />
        </div>
        <div className="col-12 col-sm-12 col-md-6">
          {statisticsData && <Provider
            providerList={statisticsData.data.providers as unknown as ProvidersObject}
            defaultQueryParams={queryParams}
            updateQueryParams={updateQueryParamsAndCallAPI}
          />}
        </div>
      </div>
      <div className="row">
        <div className="mt-3">
          {statisticsData && <CaseDetail type="territories" baseUrl="/territories" searchParams={{ ...queryParams, id: Number(queryParams?.id ?? "0") }} CaseDetailListType={statisticsData.data.case_listing as unknown as CaseListingType[]} />}
        </div>
      </div>
      <div className="row">
        <div className="mt-3">
          {statisticsData && <OngoingTreatment type="territories" baseUrl="/territories" searchParams={{ ...queryParams, id: Number(queryParams?.id ?? "0") }} CaseDetailListType={statisticsData.data.ongoing_treatments as unknown as onGoingTreatmentType[]} />}
        </div>
      </div>
      <FooterText />
    </div>

  );
};

export default Territories;
